<template>
  <UiCurtain
    :open="curtainOpen"
    @close="$emit('close')"
    @curtain-scroll="onCurtainScroll"
  >
    <form
      ref="formFilters"
      class="filters-wrap"
      :class="{ 'show-more': showMoreFilters }"
      novalidate
      action="."
    >
      <div class="category-products body-l-regular">
        Товаров
        {{
          isSearch || (values.active && values.active.length)
            ? 'найдено'
            : whereStr
        }}:
        {{ products ? products.toLocaleString('ru') : ' ' }}
      </div>
      <div :class="['header-mobile', { sticky: clearFixed }]">
        <div class="heading-m">Фильтры</div>
        <div
          v-show="choosed && !values.active?.length"
          class="text-button"
          @click="$emit('clear-active', false)"
        >
          Сбросить выбранные
        </div>
      </div>
      <FiltersActiveFilters
        v-if="filters && values.initiated && isMobile"
        :list="values.active"
        @cancel="(i) => $emit('cancel-active', i)"
        @clear-all="$emit('clear-active', true)"
      />
      <slot name="before-price" />
      <template v-if="filters && values.initiated">
        <div v-if="showBestPrice" class="filter filter--best-price">
          <UiButtonToggle
            emit-position
            class="filter-item in-list"
            :gradient-border="true"
            responsive
            :title="filters?.best_price?.name"
            :value="values.best_price"
            @change-toggle="changeToggleBestPrice"
            @position="onPositionChange"
          />
        </div>
        <ui-slide-down
          v-if="filters?.price && values.price?.value"
          class="filter price"
          open
          @change="$emit('update:position', null)"
        >
          <template #header="{ visible }">
            <div class="filter-header">
              <div class="filter-title body-m-semibold">Цены, ₽</div>
              <div class="is-body-opened" :class="{ closed: !visible }" />
            </div>
          </template>
          <div class="filter-body">
            <RANGE
              :settings="filters.price"
              :value="values.price.value"
              emit-position
              @on-change="(e) => $emit('filters-change', e, 'price')"
              @position="onPositionChange"
              @get-filters="getWithNew"
            />
          </div>
        </ui-slide-down>

        <ui-slide-down
          v-if="isFiltersBrands"
          class="filter brands"
          open
          @change="$emit('update:position', null)"
        >
          <template #header="{ visible }">
            <div class="filter-header">
              <div class="filter-title body-m-semibold">Производитель</div>
              <div class="is-body-opened" :class="{ closed: !visible }" />
            </div>
          </template>
          <template #default="{ setAutoHeight }">
            <ui-p-input
              :value="brandQuery"
              name="search"
              placeholder="Найти"
              class="brands-search"
              type="search"
              @focus="setAutoHeight"
              @input="(v) => $emit('update:brandQuery', v)"
            >
              <template #left>
                <img class="icon" src="/static/images/search.svg" alt="" />
              </template>
            </ui-p-input>
            <ENUM
              v-if="brands.length > 0"
              :settings="{ allowed_values: brands }"
              :value="values?.brands?.value"
              @on-change="(e) => $emit('filters-change', e, 'brands')"
              @position="onPositionChange"
              @show="setAutoHeight"
              @get-filters="getWithNew"
            />
            <div v-else>Ничего не найдено</div>
          </template>
        </ui-slide-down>
        <template v-if="!showMinimalFilters">
          <ui-slide-down
            v-for="(item, index) in filtersContainsDate"
            :key="`${item.id}`"
            :open="index < 6"
            class="filter"
            @change="$emit('update:position', null)"
          >
            <template #header="{ visible }">
              <div class="filter-header">
                <div
                  class="filter-title body-m-semibold"
                  :class="{ 'filter-title__gray': isAllNotActive(item) }"
                >
                  {{ item?.name }}{{ item.unit ? ', ' + item.unit : '' }}
                </div>
                <ui-hint
                  v-if="item.description"
                  :text="item.description"
                  class="filter-hint"
                />
                <div class="is-body-opened" :class="{ closed: !visible }" />
              </div>
            </template>
            <template #default="{ calcStyle }">
              <component
                :is="viewComponent(item.type)"
                :id="item.id"
                class="filter-body"
                :settings="item"
                :value="getValue(item.id)"
                emit-position
                @on-change="(e) => $emit('filters-change', e)"
                @show="calcStyle"
                @position="onPositionChange"
                @get-filters="getWithNew"
              />
            </template>
          </ui-slide-down>
          <ui-ui-button
            v-if="isShowMoreButton"
            :resize="true"
            :font-weight="400"
            type="neutral"
            class="show-more-button"
            @click="showMoreFilters = true"
          >
            Показать еще
          </ui-ui-button>
        </template>
        <ui-slide-down
          v-if="isFiltersShops"
          class="filter brands"
          open
          @change="$emit('update:position', null)"
        >
          <template #header="{ visible }">
            <div class="filter-header">
              <div class="filter-title body-m-semibold">Продавец</div>
              <div class="is-body-opened" :class="{ closed: !visible }" />
            </div>
          </template>
          <template #default="{ setAutoHeight }">
            <ui-p-input
              :value="shopQuery"
              name="search"
              placeholder="Найти"
              class="brands-search"
              type="search"
              @focus="setAutoHeight"
              @input="(v) => $emit('update:shopQuery', v)"
            >
              <template #left>
                <img class="icon" src="/static/images/search.svg" alt />
              </template>
            </ui-p-input>
            <ENUM
              v-if="shops?.length > 0"
              :settings="{ allowed_values: shops }"
              :value="values.shops?.value"
              @on-change="(e) => $emit('filters-change', e, 'shops')"
              @position="onPositionChange"
              @show="setAutoHeight"
              @get-filters="getWithNew"
            />
            <div v-else>Ничего не найдено</div>
          </template>
        </ui-slide-down>
      </template>
      <template v-else>
        <div v-for="n in 4" :key="n" class="skeleton-wrap">
          <div class="skeleton-block range">
            <div class="control top" />
            <div class="input-range" />
            <div class="checkbox" />
          </div>
          <div class="skeleton-block enum">
            <div class="control top" />
            <div class="input-text" />
            <div v-for="i in 10" :key="i" class="checkbox" />
            <div class="control" />
          </div>
        </div>
      </template>
      <slot name="after-filters" />
      <filters-filters-get
        v-if="filters && values.initiated"
        v-show="(!!position && isChanged) || isDontDesktop"
        :style="position"
        :loading="loading"
        :count="countResult"
        :button-style="isMobile"
        @get-filters="getWithNew"
      />
    </form>
  </UiCurtain>
</template>

<script setup lang="ts">
import ENUM from '~/components/filters/enum-filter-listings/enum-filter-listings.vue';
import RANGE from '~/components/filters/range-input/range-input.vue';
import BOOL from '~/components/filters/boolean-filter/boolean-filter.vue';
import type {
  FiltersListings,
  filtersValues,
  PaginationElementTarget,
  ItemFilter,
} from '~/interfaces/app';
import { useMediaQueryStore } from '~/stores/mediaQuery';

const props = defineProps({
  values: {
    type: Object as () => filtersValues,
    required: true,
  },
  filters: {
    type: Object as () => FiltersListings,
    required: true,
  },
  filtersGetQuery: {
    type: Object as () => FiltersListings,
    required: true,
  },
  loading: {
    type: Boolean,
    required: true,
  },
  products: {
    type: Number,
    default: 0,
  },
  count: {
    type: Number,
    required: true,
  },
  curtainOpen: {
    type: Boolean,
    required: true,
  },
  position: {
    required: true,
  },
  isMobile: {
    type: Boolean,
    default: false,
  },
  choosed: {
    type: Boolean,
    default: false,
  },
  isSearch: {
    type: Boolean,
    default: false,
  },
  isChanged: {
    type: Boolean,
    default: true,
  },
  showMinimalFilters: {
    type: Boolean,
    default: false,
  },
  whereStr: {
    type: String,
    default: 'в категории',
  },
  brandQuery: {
    type: String,
    default: '',
  },
  shopQuery: {
    type: String,
    default: '',
  },
  goToSlug: {
    type: String,
    default: '',
  },
});

const emit = defineEmits([
  'update:position',
  'get-with-new',
  'close',
  'update:brandQuery',
  'update:shopQuery',
  'clear-active',
  'cancel-active',
  'filters-change',
  'changeFiltersQuery',
]);
const viewComponent = (item: string) => {
  if (item === 'ENUM') return ENUM;
  if (item === 'RANGE') return RANGE;
  if (item === 'BOOL') return BOOL;
  return null;
};
const route = useRoute();
const router = useRouter();
const showMoreFilters = ref<boolean>(false);
const formFilters = ref<HTMLElement>();
const clearFixed = ref<boolean>(false);
const changeQuery = ref<boolean>(false);
const isBestPrice = ref<boolean>(false);
const mediaStore = useMediaQueryStore();
const isDontDesktop = computed(
  () =>
    mediaStore.isLessEs || mediaStore.isEs || mediaStore.isSm || mediaStore.isMd
);
const { $ymAnyEvent } = useNuxtApp();

const showBestPrice = computed(() => props.filters?.best_price?.filter);

const brands = computed(() => {
  if (props.brandQuery.length > 1 && props.filters?.brands)
    return props.filters.brands
      .filter(
        (el) =>
          el?.name?.toLowerCase().indexOf(props.brandQuery.toLowerCase()) === 0
      )
      .slice(0, 10);
  return props.filters?.brands || [];
});

const shops = computed(() => {
  if (props.shopQuery.length > 1 && props.filters?.shops)
    return props.filters.shops
      .filter(
        (el) =>
          el?.name.toLowerCase().indexOf(props.shopQuery.toLowerCase()) === 0
      )
      .slice(0, 10);
  return props.filters?.shops || [];
});

watch(
  () => route.query,
  () => {
    changeQuery.value = true;
  }
);

const countResult = computed(() => {
  return props.choosed || isBestPrice.value
    ? props.count
    : props?.filters?.count;
});

// тут содержаться данные для фильтров, где count > 0
const filtersContainsDate = computed(() => {
  return props.filters.filters;
});

const onPositionChange = (e: { right: number; top: number }): void => {
  if (formFilters.value) {
    const { left, top } = formFilters.value?.getBoundingClientRect();
    emit('update:position', {
      left: e.right - left + 16 + 'px',
      top: e.top - top - window.scrollY + 'px',
    });
  }
};

const onCurtainScroll = (e: PaginationElementTarget): void => {
  clearFixed.value =
    !!props.choosed &&
    !!props.isMobile &&
    !props.values?.active?.length &&
    e?.target?.scrollTop > 40;
};

const isFiltersBrands = computed(
  () => props.filters?.brands?.length && !!props.values.brands
);
const isFiltersShops = computed(
  () => props.filters?.shops?.length && !!props.values.shops
);

const isShowMoreButton = computed<boolean>(
  () =>
    !showMoreFilters.value &&
    props.filters.filters &&
    props.filters.filters.length > 14
);

const getValue = (id: number) => {
  if (!id) return undefined;
  return props.values?.filters[id]?.value;
};

function changeToggleBestPrice(val: boolean) {
  if (val) {
    $ymAnyEvent('reachGoal', 'filter_best_price');
  }
  emit('filters-change', { id: '', val, queryVal: 'best_price' }, 'best_price');
  isBestPrice.value = val;
}

const setNewQuery = () => {
  const queryEntries = Object.entries(route.query);
  const newQuery = {};

  for (const [key, value] of queryEntries) {
    const newAttr: { [key: string]: string } = {};
    // Обработка атрибутов вида attr-123
    if (key.startsWith('attr-')) {
      const [, numberAttr] = key.match(/attr-(\d+)/) || [];
      const numericValue = Number(numberAttr);

      if (numberAttr && value) {
        const filter = props.filtersGetQuery.filters.find(
          (el) => el.id === numericValue
        );
        if (filter) {
          const attrValues = String(value).split(',');
          const validValues = [];

          for (const attrValue of attrValues) {
            if (filter.type === 'BOOL') {
              validValues.push(attrValue);
            } else if (
              filter.allowed_values?.some((v) => v.id === Number(attrValue))
            ) {
              validValues.push(attrValue);
            }
          }

          newAttr[`attr-${numberAttr}`] = validValues.join(',');
        }
      }
    }
    // Обработка shop_ids
    else if (key === 'shop_ids' && value && props.filtersGetQuery?.shops) {
      const validShops = String(value)
        .split(',')
        .filter((shopId) =>
          props.filtersGetQuery.shops.some((shop) => shop.id === Number(shopId))
        );
      newAttr[key] = validShops.join(',');
    }
    // Копирование других параметров, кроме brand_id
    else if (key !== 'brand_id') {
      newAttr[key] = Array.isArray(value) ? value.join(',') : value;
    }

    Object.assign(newQuery, newAttr);
  }

  return newQuery;
};

function hasSingleBrandId(queryString: string) {
  const params = new URLSearchParams(queryString);
  const brandIds = params.getAll('brand_id');
  if (brandIds.length !== 1) {
    return false;
  }
  const value = brandIds[0];
  return value !== '' && !value.includes(',');
}

const getWithNew = () => {
  $ymAnyEvent('reachGoal', 'Filtration');
  if (
    props.goToSlug &&
    props.goToSlug !== route.path.replace(/^\/?|\/?$/g, '')
  ) {
    emit('changeFiltersQuery', 'true');
    emit('close');

    setTimeout(() => {
      if (
        hasSingleBrandId(
          Object.keys(route.query)
            .map((key) => `${key}=${route.query[key]}`)
            .join('&')
        )
      ) {
        const query = setNewQuery();
        router?.push({
          path: '/' + props.goToSlug + '/',
          query: { ...query },
        });
      } else {
        emit('get-with-new');
        emit('close');
        emit('update:brandQuery', '');
        emit('update:shopQuery', '');
      }
    }, 150);
  } else {
    emit('get-with-new');
    emit('close');
    emit('update:brandQuery', '');
    emit('update:shopQuery', '');
  }
};

const isAllNotActive = (item: ItemFilter) => {
  if (item.type !== 'ENUM') {
    return 'active' in item ? !item.active : false;
  } else if (item?.allowed_values && item?.allowed_values.length) {
    return item?.allowed_values.reduce((a: boolean, i) => {
      return 'active' in i && i.active ? false : a;
    }, true);
  }
  return true;
};
</script>
<style scoped lang="scss" src="./filters.scss"></style>
